import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useI18n } from '@popety_io/popety-io-lib'
import { estimateSelector } from '../../../redux'
import { PriceDisplay } from './PriceDisplay'

export const PriceRangeDisplay = () => {
  const estimate = useSelector(estimateSelector)
  const { t } = useI18n()

  const calculatePerM2 = (value?: number) => {
    if (!value) return 0

    if (estimate?.isCaculatorByWeightedLivingArea === 'no_area') return 0

    const isCaculatorByWeightedLivingArea =
      estimate?.isCaculatorByWeightedLivingArea === 'weightedLivingArea'

    const area = isCaculatorByWeightedLivingArea
      ? estimate?.weightedLivingArea || 0
      : estimate?.area || 0

    if (!area) return 0

    return Math.round(value / area)
  }

  const showPerM2 = estimate?.isCaculatorByWeightedLivingArea !== 'no_area'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingBottom: '5px',
        paddingTop: '5px',
        gap: '20px',
      }}
    >
      <Box sx={{ display: 'flex', gap: '10px', paddingBottom: '5px' }}>
        <Typography fontWeight="500" fontSize="1rem">
          {t('estimate.summary.Fourchette haute')}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <PriceDisplay
            value={estimate?.upperRange}
            perM2Value={calculatePerM2(estimate?.upperRange)}
            showPerM2={showPerM2}
          />
        </Box>
      </Box>

      <Box>
        <PriceDisplay
          value={estimate?.price}
          fontSize="2.5rem"
          fontSizeM2="1.2rem"
          perM2Value={calculatePerM2(estimate?.price)}
          showPerM2={showPerM2}
        />
      </Box>

      <Box sx={{ display: 'flex', gap: '10px', paddingBottom: '5px' }}>
        <Typography fontWeight="500" fontSize="1rem">
          {t('estimate.summary.Fourchette basse')}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <PriceDisplay
            value={estimate?.lowRange}
            perM2Value={calculatePerM2(estimate?.lowRange)}
            showPerM2={showPerM2}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default PriceRangeDisplay
